export const MEETING_DATE_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Edmonton",
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
});

export const MEETING_TIME_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Edmonton",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});
